import { getDefaultAdvertiserPagination } from "advertiser/tools/list"
import { NOT_SAVED_ID } from "app/model"
import { isDesktopScreen } from "ui/tools/responsive"
import { IAdvertiserFilters, IAdvertiserForm, IAdvertiserFormData, IAdvertiserList, IAdvertiserState } from "../model"

export function getDefaultAdvertiserState(): IAdvertiserState {
  return {
    advertisers: [],
    advertiserDomains: [],
    form: getDefaultAdvertiserFormState(),
    isFormPopupOpened: false,
    list: getDefaultAdvertiserListState()
  }
}

export function getDefaultAdvertiserFilters(): IAdvertiserFilters {
  return {
    name: ""
  }
}

function getDefaultAdvertiserListState(): IAdvertiserList {
  return {
    filteredAdvertisers: [],
    filters: getDefaultAdvertiserFilters(),
    isFilterExpanded: isDesktopScreen(),
    isRefreshing: false,
    hasRefreshError: false,
    pagination: getDefaultAdvertiserPagination(),
    rowCount: 0
  }
}

export function getDefaultAdvertiserFormState(): IAdvertiserForm {
  return {
    hasChanged: false,
    initialData: getDefaultData(),
    data: getDefaultData(),
    errors: {},
    isCreation: true,
    isLoading: false,
    hasLoadingError: false,
    isSaving: false,
    isValid: false,
    advertiserId: NOT_SAVED_ID
  }
}

function getDefaultData(): IAdvertiserFormData {
  return {
    name: "",
    media_fee_percent: null
  }
}
